
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcast",
      function () {
        return require("private-next-pages/podcast/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcast"])
      });
    }
  